import { render, staticRenderFns } from "./smedias.vue?vue&type=template&id=1408d13d&scoped=true"
import script from "./smedias.vue?vue&type=script&lang=js"
export * from "./smedias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1408d13d",
  null
  
)

export default component.exports